import { CardActions } from '@client/toolkit';
import { useTranslation } from 'react-i18next';
import { PermissionKeys } from '@client/api';
import { SpacePermissionBasedActionButton } from '../../../../../../../components/space-permission-based-button/space-permission-based-button';

export type SpaceCardActionsProps = {
  loading: boolean;
  spaceId: string;
  handleCreate: () => void;
};

export function SpaceCardActions({ loading = false, spaceId, handleCreate }: SpaceCardActionsProps) {
  const { t: tCommon } = useTranslation();

  return (
    <CardActions>
      <SpacePermissionBasedActionButton
        spaceId={spaceId}
        onClick={handleCreate}
        permissions={[PermissionKeys.Space.SubspacesCreate]}
        title={tCommon('create')}
        disabled={loading || spaceId == null}
      />
    </CardActions>
  );
}
